import { RecallTopicDao } from '@rock/db-admin';

const recallTopicDao = new RecallTopicDao();

/** Every recall topic in list order, live — the Topics tab, a recall's Topics pills and the list's Topics column. */
export const recallTopicsState = recallTopicDao.recallTopicsAtom();
